module.exports = {"451224100":"东兰镇","451224101":"隘洞镇","451224102":"长乐镇","451224103":"三石镇","451224104":"武篆镇","451224105":"长江镇","451224200":"泗孟乡","451224201":"兰木乡","451224203":"巴畴乡","451224204":"金谷乡","451224205":"三弄瑶族乡","451224206":"大同乡","451224207":"花香乡","451224208":"切学乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451224.json
// module id = 2292
// module chunks = 0